import * as filestack from 'filestack-js';
import merge from 'lodash/merge';

const client = filestack.init('AGpNE5gGQESN0J1jlFDiAz');

const ACCEPT_MIME = [
  'image/jpeg',
  'image/png',
  'application/zip',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-powerpoint.presentation.macroenabled.12', // MLD-6004 custom
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/pdf',
  'video/mp4',
  'video/mpeg',
  'video/quicktime',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.oasis.opendocument.spreadsheet',
  'image/vnd.dwg',
  'image/vnd.dxf',
  'application/postscript',
  'image/svg+xml',
];

export default {
  client,
  showPicker(options) {
    let pickerOptions = {
      fromSources: [
        'local_file_system',
        'box',
        'dropbox',
        'googledrive',
        'onedrive',
      ],
      // MLD-6004
      // @see https://filestack.github.io/filestack-js/interfaces/PickerOptions.html#accept
      // @see https://www.filestack.com/docs/uploads/pickers/web/#callbacks
      acceptFn: async (file, options) => {
        let mimeTest = '';
        if (file.source === "local_file_system") {
          const magicMime = await options.mimeFromMagicBytes(file.originalFile)
          const extMime = await options.mimeFromExtension(file.originalFile.name)
          mimeTest = magicMime; // magicMime.indexOf("audio/") >= 0 ? magicMime : extMime
          // Use mimeType if it's set
        } else if (file.mimetype) {
          mimeTest = file.mimetype
          // Fall back to Filestack's built-in extension detector
        } else {
          mimeTest = await options.mimeFromExtension(file.name)
        }

        if (ACCEPT_MIME.includes(mimeTest) === false) {
          return Promise.reject('Please upload a valid audio file.')
        }
        return Promise.resolve();
      },
    };
    merge(pickerOptions, options);
    client.picker(pickerOptions).open();
  }
}
